import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'translations';
import { Field } from 'redux-form';
import { Layout, Flex } from 'app/components/base/Layout';
import TransitionInput from 'app/components/base/TransitionInput';
import PasswordCaption from '../PasswordCaption';
import { PASSWORD_FIELD_NAME } from 'app/constants';

import style from './style.css';

const messages = {
  password: { id: 'BOOK_TRIP.CONTACT_INFO.PASSWORD' },
};

/**
 * Disables autofilling of actual password input in Chrome and
 * probably in other browsers.
 * See https://stackoverflow.com/a/15917221
 */
const DisableChromeAutofill = () => (
  <div className={style.hiddenFakeInput}>
    <input type="text" name="fakeusrname" />
    <input type="password" name="fakepwd" />
  </div>
);

const PasswordBox = ({ className, mobile }) => {
  const size = mobile ? '100' : '50';
  return (
    <Layout
      align="space-between center"
      className={classnames(style.container, className)}
    >
      <Flex size={size} className={style.field}>
        <DisableChromeAutofill />
        <Field
          compact
          component={TransitionInput}
          name={PASSWORD_FIELD_NAME}
          type="password"
          label={<FormattedMessage {...messages.password} />}
          upwards
        />
      </Flex>
      <Flex size={size} className={style.caption}>
        <PasswordCaption mobile={mobile} />
      </Flex>
    </Layout>
  );
};

// TODO: move to Flow types
// PasswordBox.propTypes = {
//   className: PropTypes.string,
//   mobile: PropTypes.bool
// };

export default PasswordBox;
